import { Box, Grid2, Stack } from "@mui/material";
import { stickyContent } from "./content";
import { StickyContent } from "./sticky-content";
import stickyImage from "../../../assets/join-as-designer-page/scroll-image.jpg";
import { useEffect, useLayoutEffect, useRef, useState } from "react";

export const StickyContentSection = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [imagePosition, setImagePosition] = useState<null | number>(null);
  const [imageWidth, setImageWidth] = useState<null | number>(null);
  const [maxScroll, setMaxScroll] = useState<null | number>(null);
  const imageRef = useRef<HTMLImageElement>(null);
  const imageContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useLayoutEffect(() => {
    if (imageRef.current) {
      setImagePosition(
        imageRef.current.getBoundingClientRect().top + window.scrollY
      );
      setImageWidth(imageRef.current.offsetWidth);
    }
  }, []);

  useLayoutEffect(() => {
    if (imageContainerRef.current) {
      setMaxScroll(imageContainerRef.current.scrollHeight);
    }
  }, []);

  const hasScrolledPastImage =
    !!imagePosition && scrollPosition >= imagePosition;
  const hasScrolledToBottom = false;

  return (
    <div className="site-wrapper">
      <Grid2 container columns={12} spacing={3}>
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <Stack spacing={3} sx={{ maxWidth: "530px" }}>
            {stickyContent.map((content) => (
              <StickyContent {...content} scrollPosition={scrollPosition} />
            ))}
          </Stack>
        </Grid2>

        <Grid2
          size={{ xs: 12, sm: 6 }}
          sx={{ position: "relative" }}
          ref={imageContainerRef}
        >
          <Box
            ref={imageRef}
            sx={{
              position: hasScrolledToBottom
                ? "absolute"
                : hasScrolledPastImage
                ? "fixed"
                : "static",
              top: hasScrolledToBottom ? "auto" : 0,
              bottom: hasScrolledToBottom ? 0 : "auto",
              width: imageWidth,
              display: {
                xs: "none",
                sm: "flex",
              },
              height: "100vh",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              style={{
                maxWidth: 530,
                margin: "0 auto",
              }}
              className="full-width-image"
              src={stickyImage}
              alt="graphic-for-design"
            />
          </Box>
        </Grid2>
      </Grid2>
    </div>
  );
};
